module.exports = __webpack_public_path__ + "img/Sin título_1.6.1(1).1f79e47f.jpg";